// Convert various video sources to an embed URL
export function toEmbedUrl(type, url) {
  if (!url) return "";
  if (type === "youtube") {
    // Accept: youtube.com/watch?v=X, youtu.be/X, youtube.com/embed/X, youtube.com/live/X
    try {
      const u = new URL(url);
      if (u.hostname.includes("youtu.be")) {
        return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
      }
      if (u.pathname.startsWith("/embed/")) return url;
      if (u.pathname.startsWith("/live/")) {
        return `https://www.youtube.com/embed/${u.pathname.split("/live/")[1]}`;
      }
      const v = u.searchParams.get("v");
      if (v) return `https://www.youtube.com/embed/${v}`;
    } catch (_) { /* ignore */ }
    return url;
  }
  if (type === "facebook") {
    // Wrap FB URL in the plugin embed
    const encoded = encodeURIComponent(url);
    return `https://www.facebook.com/plugins/video.php?href=${encoded}&show_text=false&width=560`;
  }
  return url; // direct URL / upload / vmix HLS
}

export function isDirectVideo(type) {
  return type === "url" || type === "upload" || type === "vmix";
}

export function youtubeThumb(url) {
  try {
    const u = new URL(url);
    let id = "";
    if (u.hostname.includes("youtu.be")) id = u.pathname.slice(1);
    else if (u.pathname.startsWith("/embed/")) id = u.pathname.split("/embed/")[1];
    else if (u.pathname.startsWith("/live/")) id = u.pathname.split("/live/")[1];
    else id = u.searchParams.get("v") || "";
    if (id) return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  } catch (_) { /* ignore */ }
  return null;
}
